<template>
  <tr>
    <td class="has-Checkbox">
      <input type="checkbox" :value="item.id" @change="onChange" :checked="isChecked" :id="`sel${index + 1}`" />
    </td>
    <td>
      <label class="postsTable__ItemTitle" :for="`sel${index + 1}`">{{ getProperty('name') }}</label>
      <ul class="postsTable__ItemActions">
        <li>
          <router-link :to="{ name: 'Edit tag', params: { id: item.id }, query: { lang } }" append>Edit</router-link>
        </li>
        <li>
          <button @click="disable('tag')">{{ disableLabel }}</button>
        </li>
      </ul>
    </td>
    <td width="200">{{ capitalize(item.type) }}</td>
  </tr>
</template>

<script>
import EventBus from '@/bus.js'

import IsChecked from '@/components/mixins/IsChecked.js'
import DisableItem from '@/components/mixins/DisableItem.js'
import GetProperty from '@/components/mixins/GetProperty.js'
import GetTagByType from '@/components/mixins/GetTagByType.js'
import Capitalize from '@/components/mixins/Capitalize.js'

export default {
  props: ['item', 'index', 'selected', 'lang', 'type'],
  mixins: [IsChecked, DisableItem, GetProperty, GetTagByType, Capitalize],
  name: 'Tag',
  data() {
    return {
      status: this.item.status,
    }
  },
  computed: {
    l10n() {
      return this.item.l10n
    },
  },
  created() {
    EventBus.$on('actionDisable', (ids) => {
      ids = JSON.parse(ids)
      if (ids.includes(this.item.id)) {
        this.disabler('tag')
      }
    })
  },
}
</script>
